import { useNavigate } from 'react-router-dom';
import SITE from '../data/site';

export default function Services() {
  const nav = useNavigate();
  const { services } = SITE;

  return (
    <div style={{ paddingTop: 72 }}>
      <div className="page-band">
        <div className="container">
          <div className="breadcrumb">
            <a onClick={() => nav('/')}>الرئيسية</a><span>/</span>الخدمات
          </div>
          <h1>خدماتنا</h1>
        </div>
      </div>

      <section className="sec">
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">تخصصاتنا</span>
            <h2>خدمات مركز العراب</h2>
            <p>نسعى جاهدين لتوفير علاجات شاملة ومبتكرة لمشاكل الفم والأسنان</p>
            <div className="gold-line" />
          </div>
          <div className="svc-grid">
            {services.map(s => (
              <div className="svc-card" key={s.id} onClick={() => nav(`/services/${s.id}`)}>
                {s.img
                  ? <img className="svc-img" src={s.img} alt={s.title} />
                  : <div className="svc-img-ph"><span className="ph-icon">{s.icon}</span><span className="ph-txt">{s.title}</span></div>
                }
                <div className="svc-body">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <span className="svc-arrow">اعرف أكثر →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
